import axiosApi from './util'
import store from '../store'

export default {
  query (query) {
    return new Promise( (resolutionFunc, rejectionFunc) => {
      return axiosApi.post('/graphql', query)
        .then(response => {
          if (response.data.errors) {
            const statusCodes = []
            const errorMessages = []
            const validateFeedback = {}
            for (const error of response.data.errors) {
              const errorObj = JSON.parse(error.message)
              statusCodes.push(errorObj.status_code)
              for (const errorMessage of errorObj.messages) {
                errorMessages.push(errorMessage)
              }
              for (const key in errorObj.validate_feedback) {
                const validateErrorMessages = []
                for (const err of errorObj.validate_feedback[key]) {
                  validateErrorMessages.push(err)
                }
                validateFeedback[key] = validateErrorMessages
              }
            }
            
            const mergedError = {
              statusCodes: statusCodes, 
              messages: errorMessages, 
              validateFeedback: validateFeedback, 
            }

            for (const statusCode of statusCodes) {
              if (statusCode === 403) {
                store.commit('set', ['permissionInsufficient', true])
                rejectionFunc(mergedError)
              }
            }
            if (mergedError.messages.length > 0) {
              store.commit('set', ["errors", mergedError])
            }
            
            rejectionFunc(mergedError)
          } else {
            resolutionFunc(response.data.data)
          }
        }, err => {
          console.log(err)
          rejectionFunc(err)
        })
    })
  },
}